import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { OneDriveItem } from 'owa-fileprovider-services';
import { ShareableFolderModel } from '../store/schema/FolderModel';

export function createShareableFolderModelForOneDriveItem(
    item: OneDriveItem,
    providerType: AttachmentDataProviderType.OneDrivePro
): ShareableFolderModel {
    const folderModel: ShareableFolderModel = {
        providerType: providerType,
        id: item.id,
        name: item.name,
        isShared: !!item.shared,
    };

    return folderModel;
}
